import { FC, ReactElement, useState } from 'react';
import IconCross from '@shared/icons/IconCross';

interface IProps {
  values: string[];
  placeholder: string;
  inputWidth?: number | string;
  onAdd: (value: string) => void;
  onRemove: (value: string) => void;
}
const TagInput: FC<IProps> = ({
  values = [],
  placeholder = '',
  inputWidth = '270px',
  onAdd,
  onRemove,
}) => {
  const [inputValue, setInputValue] = useState('');

  return (
    <div className=" w-full">
      <div className="flex items-center gap-[10px] flex-wrap">
        <div
          className={`flex items-center w-[${inputWidth}] h-[39px] text-[16px]  border border-[#211F24] rounded-[10px] px-[10px]`}
        >
          <input
            type="text"
            value={inputValue}
            onChange={e => setInputValue(e.target.value)}
            placeholder={placeholder}
            className="w-full bg-transparent outline-none placeholder:text-[#959595]"
          />
          <div
            onClick={() => {
              onAdd(inputValue);
              setInputValue('');
            }}
            className="flex justify-center items-center cursor-pointer rotate-45 bg-[#232225] w-[13px] h-[13px] rounded-[50%]"
          >
            <IconCross height={6} width={6} />
          </div>
        </div>

        {values.map((item: string, index: number) => (
          <div
            key={index}
            className="flex items-center justify-center h-[39px] text-[16px] gap-[10px] border border-[#211F24] rounded-[10px] px-[10px]"
          >
            <span>{item}</span>
            <div
              onClick={() => onRemove(item)}
              className="flex justify-center items-center cursor-pointer bg-[#232225] w-[13px] h-[13px] rounded-[50%]"
            >
              <IconCross height={6} width={6} fill="#E23336" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TagInput;
